import React from "react";
import Button from "../../common/Button";
import Logo from "../../../assets/logo.svg";
import Facebook from "../../../assets/icons/facebook.svg";
import Twitter from "../../../assets/icons/twitter.svg";
import Linkedin from "../../../assets/icons/linkedin.svg";
import Youtube from "../../../assets/icons/youtube.svg";
import Shadow from "../../../assets/shadows/1.png";

const Footer = () => {
  return (
    <div className="px-5 py-16 relative">
      <div className="max-w-5xl mx-auto">
        <div className="flex justify-between flex-col md:flex-row gap-10 md:gap-0 items-center pb-7 border-b border-b-[#B1B5C3]">
          <div className="">
            <img src={Logo} alt="logo" />
          </div>
          <div className="flex opacity-70 md:ml-[min(10vw,10rem)] flex-col md:flex-row md:gap-8 gap-5 text-center">
            <a className="cursor-pointer font-medium text-dark text-base" href="#home">
              Home
            </a>
            <a className="cursor-pointer font-medium text-dark text-base" href="#about">
              About
            </a>
            <a className="cursor-pointer font-medium text-dark text-base" href="#competition">
              Competition
            </a>
            <a className="cursor-pointer font-medium text-dark text-base" href="#timeline">
              Timeline
            </a>
            <a className="cursor-pointer font-medium text-dark text-base" href="#faq">
              FAQ
            </a>
          </div>
          <ul className="flex opacity-40">
            {/* <li className="ml-3">
              <img src={Facebook} alt="facebook" />
            </li> */}
            <li className="ml-3 cursor-pointer">
              <img src={Twitter} alt="twitter"
                onClick={() => window.open("https://twitter.com/unbigdata", "_blank")}
                className=" hover:bg-sky-400 rounded-full" />
            </li>
            {/* <li className="ml-3">
              <img src={Linkedin} alt="linkedin"/>
            </li> */}
            <li className="ml-3 cursor-pointer">
              <img src={Youtube} alt="youtube" 
                onClick={() => window.open("https://www.youtube.com/channel/UC5MZXk2PQIJvuYEgEcfG_EA", "_blank")}
                className=" hover:bg-red-400 rounded-full" />
            </li>
          </ul>
        </div>
        <div className="flex justify-between items-center mt-9 flex-col md:flex-row gap-5 md:gap-0">
          <span className="text-base text-dark opacity-40 order-3 md:order-1 text-center md:text-left">
            Copyright ©2022 © United Nations / UN-CEBD.
            <br /> All Rights Reserved.
          </span>
          <ul className="flex opacity-70 order-2 gap-8 md:flex-row flex-col">
            <li className="cursor-pointer font-medium text-dark text-base"
              onClick={() => window.open("https://www.un.org/en/about-us/privacy-notice", "_blank")}>
              Privacy Policy
            </li>
            <li className="cursor-pointer font-medium text-dark text-base"
              onClick={() => window.open("https://www.un.org/en/about-us/terms-of-use", "_blank")}>
              Terms of Use
            </li>
            <li className="cursor-pointer font-medium text-dark text-base"
              onClick={() => window.open("https://www.un.org/en/about-us/fraud-alert", "_blank")}>
              Fraud Alert
            </li>
          </ul>
          <div className="order-2 md:order-3 my-1">
            <Button onClick={() => window.open("https://discord.com/invite/KJwApgXs4s", "_blank")}>Join Discord</Button>
          </div>
        </div>
      </div>
      <img
        src={Shadow}
        alt="shadow"
        className="absolute bottom-0 left-0 z-[-1]"
      />
    </div>
  );
};

export default Footer;
